import { lazyGetFlagUnflagSections } from "owa-mail-ribbon-sections/lib/sections";

import type { MailRibbonTabId } from "owa-ribbon-ids/lib/mailRibbonId";
import type { ReadOnlyRibbonControlDefProps } from "owa-mail-ribbon-utils";
import { setMenuDefinition } from "../../mutatorActions/setMenuDefinition";

export const onFlagUnflagMenuClicked = (keytipTabId: MailRibbonTabId | undefined, props: ReadOnlyRibbonControlDefProps): void => {
    lazyGetFlagUnflagSections.import().then(getFlagUnflagSections => {
        setMenuDefinition("FlagUnflagMenuDefinitionStore", props.projectionTabId, () => {
            return {
                sections: getFlagUnflagSections(keytipTabId, props),
            };
        });
    });
};
